import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=6aaeb4c5&"
import script from "./Loaders.vue?vue&type=script&lang=ts&"
export * from "./Loaders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports